import React from 'react';

const LoaderModalComponent = () => (
    <div className="loader-root">
        <img src="/assets/img/common/loader.gif" alt="loader"/>
    </div>
);

export default LoaderModalComponent;